import {
  useCreateSupplierImportMutation,
  useSupplierImportValidationMutation,
} from '@contract-root/admin-react/src/generated/graphql';
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog';
import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ExcelInput } from '@ifca-root/react-component/src/components/Input/ExcelUploadInput';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import { useExcelUploadVersion2 } from '@ifca-root/react-component/src/utils/hooks/excelUploadVersion2';
import { List, ListItem, ListItemText } from '@material-ui/core';
import SnackBarContext from 'containers/App/Store/SnackBarContext';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';

export const SupplierImportValidation = (props: any) => {
  let history = useHistory();
  let location = useLocation();
  let user = JSON.parse(localStorage.getItem('loggedInUser'));
  const { mode } = props;
  const passedData: any = location?.state;
  const fileName = passedData?.fileName;
  const { mode: pageMode }: any = useParams();
  const [upload, setUpload] = useState('');
  const [batchID, setBatchID] = useState('');
  const [num, setNum] = useState(0);
  const { setOpenSnackBar }: any = useContext(SnackBarContext as any);
  const [openDialog, setOpenDialog] = useState(false);
  const [tempData, setTempData] = useState<any[]>([]);
  const [rowOfSupplier, setRowOfSupplier] = useState<number>(0);
  const [rowCount, setRowCount] = useState<number>(0);
  const [validatedData, setValidatedData] = useState<any>({
    ErrorData: [],
    ValidData: [],
    FileTitle: String,
  });

  const [errMsg, setErrMsg] = useState('');

  const [
    supplierImportValidation,
    { loading: supplierImportValidationLoading },
  ] = useSupplierImportValidationMutation({
    onError: error => {
      let errorMsg = error.message.substring(15);
      setErrorDialog(true);
      setErrMsg(errorMsg);
    },

    onCompleted: ({ supplierImportValidation }) => {
      setBatchID(supplierImportValidation?.batchID);
      setRowOfSupplier(supplierImportValidation?.rowCount);

      let ErrorData: any = [];
      let ValidData: any = [];
      let sumRow: number = 0;
      for (let i = 0; i < supplierImportValidation?.importData?.length; i++) {
        const x = supplierImportValidation?.importData[i];
        sumRow = i + 1;
        if (x?.err_status === true) {
          ErrorData.push({ ...x });
        } else {
          ValidData.push({ ...x });
        }
        setValidatedData({
          ErrorData: ErrorData,
          ValidData: ValidData,
          fileTitle,
        });
      }
      setRowCount(sumRow);
    },
  });

  useEffect(() => {
    if (
      !!batchID &&
      rowCount == rowOfSupplier &&
      (validatedData?.ErrorData?.length > 0 ||
        validatedData?.ValidData?.length > 0)
    ) {
      history.push({
        pathname: `/${pageMode}/general-settings/supplier-profile/validation`,
        state: { validatedData, batchID },
      });
    }
  }, [batchID, rowCount, rowOfSupplier, validatedData]);

  const [
    createSupplierImport,
    { loading: createSupplierImportLoading },
  ] = useCreateSupplierImportMutation({
    onError: error => {
      let errorMsg = error.message.substring(15);
      setErrorDialog(true);
      setErrMsg(errorMsg);
    },
    onCompleted: () => {
      history.push(`/${pageMode}/general-settings/supplier-profile/`);
    },
  });

  const handleSupplierImport = () => {
    const temp = currentData?.map(x => ({
      name: !!x['Supplier Name'] ? x['Supplier Name'] : '',
      registrationNo: !!x['Company Reg No'] ? x['Company Reg No'] : '',
      suppType: !!x['Supplier Type'] ? x['Supplier Type'] : '',
      description: !!x?.Description
        ? String(x?.Description)
        : String(`${x['Supplier Name']} - ${x['Company Reg No']}`),
      address: {
        address: x?.Address ? x?.Address : '',
        country: x?.Country ? x?.Country : '',
        state: x?.State ? x?.State : '',
        city: x?.City ? x?.City : '',
        postCode: x['Postcode'] ? String(x['Postcode']) : '',
      },
      email: !!x['Email'] ? String(x['Email']?.text ?? x['Email']) : '',
      contactNo: x['Office No'] ? String(x['Office No']) : '',
      creditTerm: x['Credit Term(Days)'],
      sstRegNo: x['SST Reg No'] ? String(x['SST Reg No']) : null,
      gstRegNo: x['GST Reg No'] ? String(x['GST Reg No']) : null,
      gstExpDate: x['GST Expiry Date'] ? x['GST Expiry Date'] : null,
      taxCode: x['Default Tax Code'] ? String(x['Default Tax Code']) : null,
      eftPayment: x['EFT Payment'] === 'Yes' ? true : false,
      bankDetails: {
        name: !!x['Bank Name'] ? x['Bank Name'] : '',
        acctHolder: !!x['Acc Holder Name'] ? x['Acc Holder Name'] : '',
        acctNo: !!x['Bank Acc No'] ? String(x['Bank Acc No']) : '',
        swiftCode: !!x['Swift Code'] ? x['Swift Code'] : '',
      },
      ratingType: x['Supplier Rating'],
      contactName: !!x['Contact Name'] ? x['Contact Name'] : '',
      contactDesignation: !!x['Contact Designation']
        ? String(x['Contact Designation'])
        : '',
      contactEmail: !!x['Contact Email']
        ? String(x['Contact Email']?.text ?? x['Contact Email'])
        : '',
      contactMobileNo: !!x['Contact Mobile No']
        ? String(x['Contact Mobile No']?.text ?? x['Contact Mobile No'])
        : '',
    }));

    supplierImportValidation({
      variables: { input: temp },
    });
  };

  const onSubmit = (data: any) => {
    createSupplierImport({
      variables: { batchID: !!batchID ? batchID : passedData?.batchID },
    });
  };

  const {
    openFileUpload,
    setOpenFileUpload,
    fileTitle,
    setFileTitle,
    openSnackBar,
    //setOpenSnackBar,
    snackBarMessage,
    setSnackBarMessage,
    currentData,
    setCurrentData,
    onUploadTemplate,
    onSelectFile,
    duplicateItems,
    errorDialog: duplicateErrorDia,
    setErrorDialog,
    resetFileUpload,
  } = useExcelUploadVersion2();

  return (
    <>
      {createSupplierImportLoading && <Loading />}
      {supplierImportValidationLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        smTitle="General Setting"
        title={user?.accountName}
        onClick={() =>
          history.push(`/supplier/general-settings/supplier-profile`)
        }
        routeSegments={[
          { name: 'General Setting' },
          { name: 'Upload Template', current: true },
        ]}
        rightRouteSegments={[{ name: 'Validation' }]}
      />

      <ContentWrapper>
        {passedData?.validatedData?.ErrorData?.length > 0 ? (
          <>
            <span className="xsTitle">
              Problem (
              <span className="highlight-text">
                {passedData?.validatedData?.ErrorData?.length}
              </span>
              )
            </span>
          </>
        ) : (
          <></>
        )}
        <List className="core-list">
          {passedData?.validatedData?.ErrorData?.map((i, index) => (
            <ListItem key={index}>
              <ListItemText
                primary={
                  <>
                    <span className="xsTitle">{i?.name}</span>
                  </>
                }
                secondary={
                  <>
                    <span className="desc extra-row">
                      <span>{i?.registration_no}</span>
                    </span>
                    <span className="desc extra-row">
                      <span
                        className="highlight-text p-l-3"
                        style={{ color: 'red' }}
                      >
                        No. {index + 1}
                      </span>
                    </span>
                    <span>{i?.err_remarks}</span>
                  </>
                }
              />
            </ListItem>
          ))}
        </List>

        {passedData?.validatedData?.ValidData?.length > 0 && (
          <span className="xsTitle">
            Validated (
            <span className="highlight-text">
              {passedData?.validatedData?.ValidData?.length}
            </span>
            )
          </span>
        )}
        <List className="core-list">
          {passedData?.validatedData?.ValidData?.map((i, index) => (
            <ListItem key={index}>
              <ListItemText
                primary={<span className="xsTitle">{i.name}</span>}
                secondary={
                  <span className="desc extra-row">
                    <span>{i.registration_no}</span>
                  </span>
                }
              />
            </ListItem>
          ))}
        </List>
      </ContentWrapper>

      <ExcelInput
        excelTitle="Supplier"
        num={num}
        setNum={setNum}
        showDupErrors={true}
        duplicateItems={duplicateItems}
        errorDia={duplicateErrorDia}
        setErrorDia={setErrorDialog}
        openUpload={openFileUpload}
        setOpenUpload={setOpenFileUpload}
        upload={fileTitle}
        template={currentData}
        setTemplate={setCurrentData}
        setUpload={setFileTitle}
        resetFileUpload={resetFileUpload}
        onUploadTemplate={() => {
          handleSupplierImport();
          setOpenFileUpload(false);
        }}
        onSelectFile={(e: any) => {
          onSelectFile({ event: e });
        }}
        onDownloadTemplate={() => {}}
        snackBarProps={{
          openSnackBar: openSnackBar,
          snackBarMessage: snackBarMessage,
          setOpenSnackBar: setOpenSnackBar,
          onClickButton: () => {
            setOpenSnackBar(false);
          },
        }}
      />

      <Footer
        options={
          passedData?.validatedData?.ErrorData?.length === 0
            ? [
                {
                  onClick: () => {
                    setOpenDialog(true);
                  },
                  name: 'Confirm Upload',
                  color: 'primary',
                },
              ]
            : [
                {
                  name: 'Re-upload',
                  color: 'primary',
                  onClick: () => {
                    setOpenFileUpload(true);
                  },
                },
              ]
        }
      />

      <CommonDialog
        fullWidth={true}
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
        }}
        sections={{
          header: {
            title: 'Supplier',
            rightText: 'Confirmation',
          },
          body: () => (
            <div className="content-wrap full text-noflow">
              <div className="mdDesc text-noflow">
                Confirm the upload of this Excel file?
              </div>
              <div className="xsTitle text-noflow">{fileName}</div>
            </div>
          ),
          footer: {
            actions: [
              {
                displayText: 'Cancel',
                props: {
                  onClick: () => {
                    setOpenDialog(false);
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
              {
                displayText: 'Confirm',
                props: {
                  onClick: () => {
                    onSubmit(createSupplierImport);
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />
    </>
  );
};
